import api from './api';
const materialsApi = api;

export const getMaterials = () => materialsApi.get('/materials');
export const getMaterial = (id) => materialsApi.get(`/materials/${id}`);
export const getDuplicateMaterials = () => materialsApi.get('/materials/duplicates');
export const removeExactDuplicates = () => materialsApi.post('/materials/remove-exact-duplicates');
export const removeAllDuplicates = () => materialsApi.post('/materials/remove-all-duplicates');
export const createMaterial = (data) => materialsApi.post('/materials', data);
export const updateMaterial = (id, data) => materialsApi.put(`/materials/${id}`, data);
export const deleteMaterial = (id) => materialsApi.delete(`/materials/${id}`);
export const mergeMaterial = (sourceId, targetId) =>
    materialsApi.post(`/materials/${sourceId}/merge-into/${targetId}`);
export const enrichMaterials = () => materialsApi.post('/materials/enrich');
